import { DataGrid, Input } from '@cimplico/components';
import { TrashIcon } from '@heroicons/react/24/outline';
import { Controller, useFormContext } from 'react-hook-form';

type NewEntryRowProps = {
    id: string;
    index: number;
    canRemove: boolean;
    isEditing: boolean;
    onDelete: (index: number) => void;
};

function NewEntryRow({ id, index, canRemove, isEditing, onDelete }: NewEntryRowProps): JSX.Element {
    const { control } = useFormContext();

    return (
        <DataGrid.Row id={id} preventDrag={!isEditing}>
            <div className={`${!isEditing ? '-ml-14' : ''} w-full md:w-[350px] grow`}>
                <Controller
                    name={`descriptions.${index}.value`}
                    control={control}
                    render={({ field: { onChange, value } }): JSX.Element => (
                        <Input
                            autoFocus={isEditing}
                            type="text"
                            size="small"
                            placeholder="Description..."
                            value={value === null ? '' : value}
                            disabled={!isEditing}
                            onChange={(e): void => {
                                onChange(e.target.value || null);
                            }}
                        />
                    )}
                />
            </div>
            {isEditing && (
                <button disabled={!canRemove} onClick={(): void => onDelete(index)} className="cursor-pointer disabled:cursor-default">
                    <TrashIcon className="w-4 h-4 text-gray-500" />
                </button>
            )}
        </DataGrid.Row>
    );
}

export default NewEntryRow;
